import { render, staticRenderFns } from "./CompanyRecommendationView.vue?vue&type=template&id=2fda7e4c&scoped=true"
import script from "./CompanyRecommendationView.vue?vue&type=script&lang=js"
export * from "./CompanyRecommendationView.vue?vue&type=script&lang=js"
import style0 from "./CompanyRecommendationView.vue?vue&type=style&index=0&id=2fda7e4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fda7e4c",
  null
  
)

export default component.exports